import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';

interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  image: string;
  slug: string;
}

export default function Blog() {
  const [selectedCategory, setSelectedCategory] = useState('Semua');

  const categories = ['Semua', 'Tips Servis', 'Teknologi', 'Desain', 'Fotografi', 'Tutorial'];

  const blogPosts: BlogPost[] = [
    {
      id: 1,
      title: '5 Tanda Laptop Anda Perlu Servis Segera',
      excerpt: 'Kenali tanda-tanda laptop yang membutuhkan perawatan profesional sebelum terlambat. Dari overheat hingga performa menurun drastis.',
      category: 'Tips Servis',
      date: '15 Maret 2024',
      readTime: '5 menit',
      image: 'https://public.readdy.ai/ai/img_res/551e2be6e5bedc1ecec735824350876f.jpg',
      slug: 'tanda-laptop-perlu-servis'
    },
    {
      id: 2,
      title: 'Cara Merawat Baterai Laptop Agar Awet',
      excerpt: 'Tips praktis merawat baterai laptop agar tetap optimal dan tahan lama. Hindari kesalahan umum yang merusak baterai.',
      category: 'Tips Servis',
      date: '12 Maret 2024',
      readTime: '4 menit',
      image: 'https://readdy.ai/api/search-image?query=laptop%20battery%20maintenance%20and%20care%20concept%20with%20charging%20cable%20and%20battery%20icon%2C%20professional%20tech%20care%20illustration%2C%20clean%20simple%20background%20highlighting%20battery%20health%20concept&width=800&height=500&seq=blog2&orientation=landscape',
      slug: 'merawat-baterai-laptop'
    },
    {
      id: 3,
      title: 'Upgrade SSD vs HDD: Mana yang Lebih Baik?',
      excerpt: 'Perbandingan lengkap antara SSD dan HDD untuk upgrade laptop Anda. Pelajari kelebihan, kekurangan, dan rekomendasi terbaik.',
      category: 'Teknologi',
      date: '10 Maret 2024',
      readTime: '6 menit',
      image: 'https://readdy.ai/api/search-image?query=solid%20state%20drive%20ssd%20and%20hard%20disk%20drive%20hdd%20comparison%20on%20clean%20desk%2C%20computer%20storage%20upgrade%20concept%2C%20professional%20tech%20comparison%2C%20simple%20background%20highlighting%20the%20storage%20devices&width=800&height=500&seq=blog3&orientation=landscape',
      slug: 'upgrade-ssd-vs-hdd'
    },
    {
      id: 4,
      title: 'Panduan Memilih CCTV untuk Rumah dan Toko',
      excerpt: 'Tips memilih sistem CCTV yang tepat sesuai kebutuhan. Dari resolusi, jenis kamera, hingga fitur remote monitoring.',
      category: 'Teknologi',
      date: '8 Maret 2024',
      readTime: '7 menit',
      image: 'https://readdy.ai/api/search-image?query=modern%20security%20camera%20cctv%20system%20for%20home%20and%20shop%2C%20professional%20surveillance%20equipment%20display%2C%20security%20technology%20concept%2C%20clean%20background%20highlighting%20the%20cctv%20cameras&width=800&height=500&seq=blog4&orientation=landscape',
      slug: 'panduan-memilih-cctv'
    },
    {
      id: 5,
      title: 'Prinsip Desain Logo yang Efektif untuk UMKM',
      excerpt: 'Pelajari prinsip dasar desain logo yang menarik dan memorable untuk bisnis UMKM Anda. Dari pemilihan warna hingga tipografi.',
      category: 'Desain',
      date: '5 Maret 2024',
      readTime: '5 menit',
      image: 'https://readdy.ai/api/search-image?query=professional%20logo%20design%20process%20for%20small%20business%20with%20sketches%20and%20digital%20tools%2C%20creative%20branding%20concept%2C%20clean%20designer%20workspace%20background%20highlighting%20the%20logo%20design&width=800&height=500&seq=blog5&orientation=landscape',
      slug: 'prinsip-desain-logo'
    },
    {
      id: 6,
      title: 'Tips Foto Produk dengan Smartphone',
      excerpt: 'Cara menghasilkan foto produk berkualitas profesional hanya dengan smartphone. Teknik lighting, komposisi, dan editing sederhana.',
      category: 'Fotografi',
      date: '3 Maret 2024',
      readTime: '6 menit',
      image: 'https://readdy.ai/api/search-image?query=smartphone%20product%20photography%20setup%20with%20lighting%20and%20product%20on%20clean%20background%2C%20mobile%20photography%20tutorial%20concept%2C%20professional%20photo%20studio%20setup%2C%20simple%20background%20highlighting%20the%20photography%20process&width=800&height=500&seq=blog6&orientation=landscape',
      slug: 'tips-foto-produk-smartphone'
    },
    {
      id: 7,
      title: 'Mengenal Panel Surya untuk Rumah Tangga',
      excerpt: 'Panduan lengkap tentang PLTS untuk rumah. Manfaat, biaya, dan cara kerja sistem panel surya yang efisien.',
      category: 'Teknologi',
      date: '1 Maret 2024',
      readTime: '8 menit',
      image: 'https://readdy.ai/api/search-image?query=solar%20panel%20installation%20on%20residential%20house%20roof%20with%20blue%20sky%2C%20renewable%20energy%20for%20home%20concept%2C%20professional%20solar%20power%20system%2C%20clean%20background%20highlighting%20the%20solar%20panels&width=800&height=500&seq=blog7&orientation=landscape',
      slug: 'mengenal-panel-surya'
    },
    {
      id: 8,
      title: 'Cara Membuat Undangan Digital yang Menarik',
      excerpt: 'Tutorial membuat undangan digital interaktif untuk pernikahan, aqiqah, atau acara spesial lainnya dengan fitur modern.',
      category: 'Tutorial',
      date: '28 Februari 2024',
      readTime: '5 menit',
      image: 'https://readdy.ai/api/search-image?query=elegant%20digital%20wedding%20invitation%20design%20on%20laptop%20and%20mobile%20screens%2C%20modern%20interactive%20invitation%20concept%2C%20beautiful%20web%20design%2C%20clean%20background%20highlighting%20the%20digital%20invitation&width=800&height=500&seq=blog8&orientation=landscape',
      slug: 'membuat-undangan-digital'
    },
    {
      id: 9,
      title: 'Pentingnya Backup Data Secara Berkala',
      excerpt: 'Mengapa backup data itu penting dan bagaimana cara melakukannya dengan benar. Hindari kehilangan data berharga Anda.',
      category: 'Tips Servis',
      date: '25 Februari 2024',
      readTime: '4 menit',
      image: 'https://readdy.ai/api/search-image?query=data%20backup%20and%20cloud%20storage%20concept%20with%20external%20hard%20drive%20and%20cloud%20icons%2C%20digital%20data%20protection%20illustration%2C%20professional%20tech%20security%2C%20clean%20background%20highlighting%20data%20backup%20concept&width=800&height=500&seq=blog9&orientation=landscape',
      slug: 'pentingnya-backup-data'
    }
  ];

  const filteredPosts = selectedCategory === 'Semua' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <Header />
      
      <div className="pt-32 pb-20">
        <div className="container mx-auto px-4">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-block mb-4">
              <span className="text-[#FF8A00] font-semibold text-sm uppercase tracking-wider bg-orange-50 px-4 py-2 rounded-full">
                Blog & Tips
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-[#0B1F3B] mb-4">
              Artikel & Tutorial Bermanfaat
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Tips, tutorial, dan informasi seputar teknologi, desain, dan servis elektronik
            </p>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-3 rounded-xl font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-[#FF8A00] text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-orange-50 hover:text-[#FF8A00] border border-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Blog Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {filteredPosts.map((post) => (
              <Link
                key={post.id}
                to={`/blog/${post.slug}`}
                className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200"
              >
                <div className="relative overflow-hidden aspect-[16/10]">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-[#FF8A00] text-white px-3 py-1 rounded-full text-sm font-semibold">
                      {post.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#0B1F3B] mb-3 group-hover:text-[#FF8A00] transition-colors line-clamp-2">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-3 leading-relaxed">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-sm text-gray-500 pt-4 border-t border-gray-100">
                    <span className="flex items-center gap-2">
                      <i className="ri-calendar-line"></i>
                      {post.date}
                    </span>
                    <span className="flex items-center gap-2">
                      <i className="ri-time-line"></i>
                      {post.readTime}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* Newsletter Section */}
          <div className="mt-16 bg-gradient-to-r from-[#0B1F3B] to-[#0d2847] rounded-3xl p-8 md:p-12 text-white">
            <div className="max-w-3xl mx-auto text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#FF8A00] rounded-2xl mx-auto mb-6">
                <i className="ri-mail-line text-3xl"></i>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                Dapatkan Tips Terbaru
              </h2>
              <p className="text-lg text-gray-300 mb-8">
                Ikuti kami di media sosial untuk mendapatkan tips dan update terbaru seputar teknologi dan servis
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a
                  href="https://wa.me/6285868360910"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 bg-[#25D366] hover:bg-[#20bd5a] text-white px-6 py-3 rounded-xl font-semibold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-fill text-xl"></i>
                  WhatsApp
                </a>
                <a
                  href="#"
                  className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-6 py-3 rounded-xl font-semibold transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-instagram-fill text-xl"></i>
                  Instagram
                </a>
                <a
                  href="#"
                  className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-6 py-3 rounded-xl font-semibold transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                  Facebook
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}